module.exports = __webpack_public_path__ + "static/media/borsa.c9f8fc4f.jpg";